import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sailings-table__container" }
const _hoisted_2 = { class: "sailings-table__header" }
const _hoisted_3 = { class: "port" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "ship" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = { class: "port" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "ship" }
const _hoisted_12 = { class: "status" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "info-container" }
const _hoisted_16 = { class: "info-container__header" }
const _hoisted_17 = {
  id: "",
  class: "info-container__content"
}
const _hoisted_18 = ["innerHTML"]

import { SailingsUpdateDepartureResponse } from "@/models/api/SailingsUpdateDepartureResponse";
import { computed, reactive } from "vue";
import _ from "lodash";
import SvgIcon from "@/components/icons/SvgIcon.vue";

interface Props {
    departures?: SailingsUpdateDepartureResponse[];
    isLoading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SailingsTable',
  props: {
    departures: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const departureGroups = computed(() => {
    if(!props.departures) return undefined;

    return _.chain(props.departures)
        .groupBy("port")
        .map((rows: [], port: string) => ({ port, rows }))
        .value();
});

const isDisabled = (status: string) => {
    if (!status) return "";

    switch (status.toLowerCase()) {
        case "arrived":
        case "cancelled":
        case "no sailing":
            return "disabled";
        default:
            return "";
    }
};

const activeMap = reactive<boolean[]>([]);

const toggleInfo = (index: number) => {
    activeMap[index] = !activeMap[index]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departureGroups.value, (departureGroup, tableIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "sailings-table",
        key: tableIndex
      }, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, _toDisplayString(_ctx.$t("sailingsTable.headers.from")) + " " + _toDisplayString(departureGroup.port.replace(/ .*/,'')), 1),
          _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.$t("sailingsTable.headers.departure")), 1),
          _createElementVNode("li", _hoisted_5, _toDisplayString(_ctx.$t("sailingsTable.headers.arrival")), 1),
          _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.$t("sailingsTable.headers.ship")), 1),
          _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.$t("sailingsTable.headers.status")), 1),
          _cache[0] || (_cache[0] = _createElementVNode("li", { class: "info" }, null, -1))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departureGroup.rows, (row, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["sailings-table__row", isDisabled(row.status)])
          }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_8, _toDisplayString(row.port), 1),
              _createElementVNode("li", _hoisted_9, _toDisplayString(row.destinationTime), 1),
              _createElementVNode("li", _hoisted_10, _toDisplayString(row.displayTime), 1),
              _createElementVNode("li", _hoisted_11, _toDisplayString(row.ship), 1),
              _createElementVNode("li", _hoisted_12, _toDisplayString(row.status), 1),
              _createElementVNode("li", _hoisted_13, [
                (row.more)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (toggleInfo((tableIndex + 1) * index))
                    }, [
                      _createVNode(SvgIcon, {
                        icon: 'carbon/info-filled',
                        width: "1.25rem",
                        height: "1.25rem"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sailingsTable.info.buttonText")), 1)
                    ], 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]),
            (row.more)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["sailings-table__info", { 'active': !!activeMap[(tableIndex + 1) * index] }])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(SvgIcon, {
                        icon: 'carbon/info-filled',
                        width: "1.25rem",
                        height: "1.25rem"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sailingsTable.info.headerText")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", {
                        innerHTML: row.more
                      }, null, 8, _hoisted_18)
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})